import React, {useEffect, useState} from 'react';

import {
  Alert,
  Dimensions,
  StyleSheet,
  Text,
  useColorScheme,
  View,
} from 'react-native';
import {useSafeAreaInsets} from 'react-native-safe-area-context';

import WebView from 'react-native-webview';
import {useDispatch} from 'react-redux';
import Header from '../../../commonComponents/Header';
import {
  hideLoader,
  showLoader,
} from '../../../commonComponents/Loader/loader.actions';
import {globalConfigurableData} from '../../../utils/globalConstant';

const AskX = ({navigation}) => {
  const [isWeburlLoaded, setIsWebUrlLoaded] = useState(false);
  const insets = useSafeAreaInsets();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(showLoader());
  }, []);

  const onMessage = () => {};

  const isWebViewLoaded = () => {
    if (!isWeburlLoaded) {
      setIsWebUrlLoaded(true);
      dispatch(hideLoader());
    }
  };

  return (
    <View style={{flexGrow: 1}}>
      <View
        style={[
          {
            // backgroundColor: Color.bgWhite,
            flexGrow: 1,
            //paddingTop: insets.top,
            //paddingBottom: insets.bottom,
            paddingLeft: insets.left,
            paddingRight: insets.right,
          },
        ]}>
        <View style={{flexGrow: 1}}>
          <Header
            isInternalPage={false}
            navigation={navigation}
            pageName={''}
            isBackgroundColor={true}
            backGroundColor="#2b2e33"
            translate={true}
          />
          <WebView
            onLoadEnd={() => isWebViewLoaded()}
            source={{uri: 'https://www.askx.me/home'}}
            style={{
              height: 1000,
              width: Dimensions.get('window').width,
              flex: 1,
              opacity: 0.99,
              overflow: 'hidden',
            }}
            originWhitelist={['*']}
            sharedCookiesEnabled={true}
            thirdPartyCookiesEnabled={true}
            cacheEnabled={true}
            domStorageEnabled={true}
            useWebKit={true}
            scalesPageToFit={false}
            onMessage={onMessage}
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({});

export default AskX;
